import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Route } from 'react-router'
import { getUserLoggedInState, getUserStatus } from 'redux/reducers/users'
import { LanguageCode } from '@cms-max/medicare-api-sdk'
import { buildLoginUrl } from 'utils/urls/buildLoginUrl'

export interface AuthenticatedRouteProps {
  children: React.ReactNode,
  exact?: boolean,
  path?: string,
  redirectPath?: string // TODO - Make this required for oauthRedirectUrl
}

export const getShouldRender = (isLoggedIn: boolean, userStatus?: string): boolean => {
  return isLoggedIn && (userStatus === 'error' || userStatus === 'finished')
}

export const getShouldRedirect = (isLoggedIn: boolean, userStatus?: string): boolean => {
  return !isLoggedIn && (userStatus === 'finished' || userStatus === 'error')
}

/**
 * Only renders the children if the user is signed in. If the user is not signed it, they are redirected
 * to the login page
 */
export const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children, redirectPath, ...otherProps }) => {
  // Login url
  const { i18n } = useTranslation()

  // Gather data to detect if should redirect and also whether children should display
  const isLoggedIn = useSelector(getUserLoggedInState)
  const userStatus = useSelector(getUserStatus)

  const shouldDisplay = useCallback(
    () => getShouldRender(isLoggedIn, userStatus),
    [isLoggedIn, userStatus]
  )

  const shouldRedirect = useCallback(
    () => getShouldRedirect(isLoggedIn, userStatus),
    [isLoggedIn, userStatus]
  )

  return (
    <Route {...otherProps}>
      {shouldDisplay() ? children : <div className='my-u-content-minheight' />}
      {shouldRedirect() && window.location.assign(buildLoginUrl(i18n.language as LanguageCode, redirectPath))}
      {/* TODO - Pass  */}
    </Route>
  )
}
